module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isNeedPopData) ? _c('div', {
    staticClass: "get-medal-pop-wrapper"
  }, [_c('div', {
    staticClass: "get-medal-infor"
  }, [_c('div', {
    staticClass: "close-popup"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closePopup
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-desc"
  }, [_c('p', {
    staticClass: "zoom"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNeedPopData.type === 'Gold'),
      expression: "isNeedPopData.type === 'Gold'"
    }],
    attrs: {
      "src": require("../../images/personal_center/medal_07.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNeedPopData.type === 'Silver'),
      expression: "isNeedPopData.type === 'Silver'"
    }],
    attrs: {
      "src": require("../../images/personal_center/medal_08.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNeedPopData.type === 'Copper'),
      expression: "isNeedPopData.type === 'Copper'"
    }],
    attrs: {
      "src": require("../../images/personal_center/medal_09.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.isNeedPopData.desc))])]), _vm._v(" "), _c('div', {
    staticClass: "link-wrapper"
  }, [_c('a', {
    staticClass: "go-link",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goLink
    }
  }, [_vm._v("点击查看我获得的奖牌")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6a4bedb0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/getMedalPop.vue
// module id = XF3z
// module chunks = 16